module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABM0lEQVRIS+2WsU7DMBRF70Ot2foHNQxITcvagYEBmOEfkBiZmBgYoCsDI2t/pRMIsSI1gQGR8hUp9CJXJBKlaZ5RyBQvlqyre6xjy7Lgezzb9UMCRzPwQICtdL3sWVzh2JorAS7LLl/WJ2G72YfIYx4siJP5phZHaA3/skGJrBkSOK4MGFrzCmCzSuBKNaUrLTqLGuh7U6VWml4a9xo5fd04mc9FZvJUFyolMFh89patac+yEKgt0uZqoNaUOlcrVavSBn8oJXiHGS+67x8jbYE2lz4UGVAED523ZEdb4Jv7BQRwHsTJtW+RNp8BI2ueCGwLedqZTG+1Bb65DDjeaN4I5QzkKJhM932LtPkM+GJN7xO4B9ByUJKDf700boeVfoRTJZFt7AJrJwT2Vn0btQrzcl8Uq5yRiLzXMgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-4-title.png
// module id = Lgwc
// module chunks = 1